import { ColorModeContext, useMode } from "../Theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import React from "react";
import Changepassword from "./Security/Changepassword";
import Listview from "./pages/Listview";
import Imageupload from "./pages/Imageupload";
import Editemployee from "./pages/HR/Editemployees";
import ListviewSecondary from "./pages/Secondarylistview";
import Editcompany from "./pages/Masters/Editcompany";
import NotFound from "./Security/NotFound";
import { MyProSidebarProvider } from "../ui-components/global/sideBarContext";
import Editleaveentry from "./pages/Empolyee/Editleaveentry";
import Editfunction from "./pages/HR/Editfunction";
import Editdesignation from "./pages/HR/Editdesignation";
import Editcheckin from "./pages/Empolyee/Editchechin";
import Editcheckout from "./pages/Empolyee/Editcheckout";
import Editlocation from "./pages/Masters/Editlocation";
import Editgate from "./pages/Masters/Editgate";
import Editbin from "./pages/Masters/Editbin";
import Editproject from "./pages/HR/Editproject";
import EditDailytask from "./pages/Empolyee/Editdailytask";
import EditDailyHourstask from "./pages/Empolyee/EditDailyHourTask";
import EditEmpCheckout from "./pages/Empolyee/EditEmpCheckout";
import Editotentry from "./pages/Empolyee/Editotentry";
import Editsalaryadvance from "./pages/Empolyee/Editsalaryadvance";
import EditAttendance from "./pages/Empolyee/EditAttendance";
import Dash from "./Dashboard/Dashboard";
import Editonduty from "./pages/Empolyee/Editonduty";
import Forgotlogin from "./Security/Forgotpassword";
import EditAttendanceHistory from "./pages/Empolyee/EditAttendaceHistory";
import EditTimeSheet from "./pages/Empolyee/EditTimeSheet";
import EditTimeDailytask from "./pages/Empolyee/EditTimeDailyTask";
import Editfinance from "./pages/FinanceModule/Editfinance";
import Editoverhead from "./pages/FinanceModule/Editoverhead";
import EditRegularization from "./pages/Empolyee/EditRegularization";
import Edittimesheetreport from "./pages/Empolyee/Edittimesheetreport";
import EditDailytaskList from "./pages/Empolyee/EditDailyTaskList";
import EditDailytaskListEdit from "./pages/Empolyee/EditDailyTaskListedit";
import EditMilestones from "./pages/HR/Editmilestone";
import Editoperation from "./pages/HR/Editoperationstage";
import EditActivities from "./pages/HR/Editactivities";
import Edittask from "./pages/HR/EditTask";
import EditmileWeightage from "./pages/HR/Editweightage";
import EditSprint from "./pages/HR/EditSprint";
import EditSpotActivity from "./pages/Empolyee/EditSpotActivity";
import Editpermission from "./pages/Empolyee/Editpermission";
import Editrole from "./pages/HR/EditRole";
import Dashboard_V2 from "./Dashboard/DashBoard_V2";
import Dashboard_V2E from "./Dashboard/EmployeeDashboard";
import Dashboard_V2M from "./Dashboard/ManagerDashBoard";
import Dashboard_V2SM from "./Dashboard/ManagerDashBoardScrum";
import Dashboard_V2SPM from "./Dashboard/ManagerDashbordSprint";
import EditdailyAttendance from "./pages/Empolyee/EditDailyattendance";
import EditRoutine from "./pages/HR/EditRoutine";
import EditQuery from "./pages/Empolyee/EditQuery";
import Topbar from "../ui-components/global/Topbar";

import EditProjectStatusReport from "./pages/Empolyee/EditProjectStatusReport";
import Editmovements from "./pages/Empolyee/Editmovements";
import EditAttendanceEntry from "./pages/Empolyee/EditAttendanceEntry";
import EditProjectEnquiry from "./pages/HR/EditProjectEnquiry";
import ListViewSkill from "./SkillGlow/ListView";
import SkillExam from "./SkillGlow/SkillExam";
import SkillReview from "./SkillGlow/SkillReview";
import SkillResultDashboard from "./SkillGlow/SkillResultDashboard";
import SkillGlowShowCase from "./SkillGlow/SkillGlowShowCase";
import CreateShowcase from "./SkillGlow/CreateShowcase";
import AppraisalListView from "./SkillGlow/AppraisalListView";
import AppraisalDashboard from "./SkillGlow/AppraisalDashboard";
import AppraisalScoreBoard from "./SkillGlow/AppraisalScoreBoard";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import EditPayment from "./pages/Empolyee/Editpayment";
import { useState } from "react";
import VerifyAssessment from "./SkillGlow/VerifyAssessment";
import EmpAssessmentDashboard from "./SkillGlow/ManagerScoreBoardView";
import TeacherCalendar from "./Dashboard/TeacherCalendar";
import ClassCalendar from "./Dashboard/ClassCalendar";
import EditHomework from "./pages/Empolyee/EditHomework";
import ProjectManagerDashboardV1 from "./Dashboard/ProjectManagerDasboardV1";
import EditHwevaluation from "./pages/Empolyee/EditHwevaluation";
import EditTimetablev1 from "./pages/Empolyee/EditTimetablev1";
import ProjectTimeTable from "./pages/Empolyee/ProjectTimeTable";
import HomeAnalytics from "./pages/Empolyee/HomeAnalytics";
import ScrumMasterDashboard from "./Dashboard/ScrumMasterDashboard";
import InvoiceAnalytics from "./pages/Empolyee/InvoiceAnalytics";
import TeacherOccupancy from "./Dashboard/TeachOccupancy";
import EditTeacher from "./pages/Empolyee/EditTeacher";
import EditClassTimetable from "./Dashboard/EditClassTimetable";
import EditTeacherinvoice from "./pages/Empolyee/EditTeacherinvoice";
import EditFeedback from "./pages/Empolyee/EditFeedback";
import Payment from "./pages/Empolyee/Payment";
import ResourceAllocation from "./pages/Empolyee/ResourceAllocation";

const IDLE_TIME = 5 * 120 * 1000;

function App() {
  // const [theme, colorMode] = useMode();

  // const navigate = useNavigate();
  // const timerRef = useRef(null);

  // const handleSessionExpire = () => {
  //   toast.error("Session expired due to inactivity. Please login again.");
  //   sessionStorage.clear();
  //   navigate("/");
  // };

  // const resetTimer = () => {
  //   clearTimeout(timerRef.current);
  //   timerRef.current = setTimeout(handleSessionExpire, IDLE_TIME);
  // };

  // useEffect(() => {
  //   // if (!sessionStorage.getItem("loginRecid")) return;

  //   const events = ["mousemove", "keydown", "scroll", "click"];

  //   events.forEach(event =>
  //     window.addEventListener(event, resetTimer)
  //   );

  //   resetTimer();

  //   return () => {
  //     events.forEach(event =>
  //       window.removeEventListener(event, resetTimer)
  //     );
  //     clearTimeout(timerRef.current);
  //   };
  // }, []);
  const [sessionTime, setSessionTime] = useState(null);

  //  Load Session Timeout (seconds → milliseconds)
  const [theme, colorMode] = useMode();
  const navigate = useNavigate();
  const timerRef = useRef(null);
  useEffect(() => {
    const timeout = sessionStorage.getItem("CompanySessionTimeOut");

    if (timeout) {
      const timeoutInMs = Number(timeout) * 1000;
      setSessionTime(timeoutInMs);
      console.log("Session timeout (ms):", timeoutInMs);
    } else {
      console.log("No CompanySessionTimeOut found in sessionStorage");
    }
  }, []);

  //  Logout function
  const handleSessionExpire = () => {
    toast.error("Session expired due to inactivity. Please login again.", {
      style: {
        fontSize: "20px",
        padding: "20px 28px",
        minWidth: "380px",
        textAlign: "center",
        lineHeight: "1.4",
      },
      autoClose: 10000,
    });

    sessionStorage.clear();
    navigate("/");
  };

  // Reset Timer
  const resetTimer = () => {
    if (!sessionTime) return;

    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(handleSessionExpire, sessionTime);
  };

  // Attach Activity Listeners
  useEffect(() => {
    if (!sessionTime) return;

    const events = ["mousemove", "keydown", "scroll", "click"];

    events.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer(); // start timer initially

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
      clearTimeout(timerRef.current);
    };
  }, [sessionTime]);

  useEffect(() => {
    const storedSessionTime = sessionStorage.getItem("sessiontime");

    if (storedSessionTime) {
      setSessionTime(storedSessionTime);
      console.log(storedSessionTime, "Session Time from storage");
    } else {
      console.log("No sessiontime found");
    }
  }, []);

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click"];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearTimeout(timerRef.current);
    };
  }, []);


  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <MyProSidebarProvider>
            <div style={{ height: "100%", width: "100%" }}>
              <main className="content">
                <Routes>
                  <Route
                    key={24234}
                    path="/dashbord/:Type"
                    element={<Dashboard_V2E />}
                  />
                  <Route
                    key={493593745}
                    path="/manager-dashbord/:Type"
                    element={<Dashboard_V2M />}
                  />
                  <Route
                    key={39530450}
                    path="/scrum-dashbord/:Type"
                    element={<Dashboard_V2SM />}
                  />
                  {/* NEW PROJECT MANAGER DASHBOARD */}
                  <Route
                    key={39530450}
                    path="/scrum-dashbord/PM"
                    element={<ProjectManagerDashboardV1 />}
                  />
                  <Route
                    key={39549359}
                    path="/sprint-dashbord/:Type"
                    element={<Dashboard_V2SPM />}
                  />

                   {/* <Route
                    key={39549364}
                    path="/scrum-master-dashbord/:Type"
                    element={<ScrumMasterDashboard />}
                  /> */}

                    <Route
                    key={39530460}
                    path="/Teacher-dashbord/:Type"
                    element={<TeacherCalendar />}
                  />
                    <Route
                    key={39530461}
                    path="/ClassCalendar-dashbord/:Type"
                    element={<ClassCalendar />}
                  />
                   <Route
                    key={39530461}
                    path="/Class-Timetable/:Type"
                    element={<EditClassTimetable />}
                  />
                  <Route
                    path="/:accessID/Editdailyattendance"
                    element={<EditdailyAttendance />}
                  />
                  <Route path="/:accessID/:screenName" element={<Listview />} />

                  {/* SKILL GLOW */}
                  {/* APPRAISAL LIST */}
                  <Route
                    path="/skillglow/Appraisallistpage/"
                    element={<AppraisalListView />}
                  />
                  <Route
                    path="/skillglow/listpage/"
                    element={<ListViewSkill />}
                  />
                  <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID2/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID1"
                    element={<ListviewSecondary />}
                  />

                  {/* STORY BOARD LIST VIEW */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID3/List Of Story Board/:accessID/:parentID2/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  {/*SESSION LIST VIEW */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID2/:accessID/List Of Session/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  {/* NEW STORY BOARD */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID3/List Of Story Board/:accessID/:parentID2/:parentID1/EditList Of Assessment/:id/:Mode"
                    element={<CreateShowcase />}
                  />
                  {/* <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID2/:parentID1"
                    element={<CreateShowcase />}
                  /> */}

                  {/* <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID2/:parentID1/EditList Of Story Board/:id/:Mode"
                    element={<CreateShowcase />}
                  /> */}

                  {/* ASSESSMENT */}
                  {/* <Route
                    path="/:accessID1/:accessID/:screenName/:parentID1/:id/:Mode"
                    element={<SkillExam />}
                  /> */}
                  {/* NEW SKILL EXAM */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID2/:screenName/:parentID1/:id/:Mode"
                    element={<SkillExam />}
                  />
                  {/* NEW VERIFY EXAM */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID2/:screenName/VerifyAssessment/:parentID1/:id/:EmployeeID"
                    element={<VerifyAssessment />}
                  />
                  <Route
                    path="/skillglow/listpage/SkillGlow/SkillReview"
                    element={<SkillReview />}
                  />
                  <Route
                    path="/skillglow/listpage/SkillGlow/SkillGlowShowCase"
                    element={<SkillGlowShowCase />}
                  />
                  <Route
                    path="/skillglow/listpage/SkillGlow/SkillExam"
                    element={<SkillExam />}
                  />
                  {/* <Route
                    path="/skillglow/listpage/SkillGlow/SkillGlowShowCase/createshowcase"
                    element={<CreateShowcase />}
                  /> */}

                  <Route
                    path="/skillglow/listpage/SkillGlow/SkillResultDashboard"
                    element={<SkillResultDashboard />}
                  />
                  <Route
                    path="/skillglow/listpage/SkillGlow/EmpDashBoard"
                    element={<EmpAssessmentDashboard />}
                  />
                  <Route
                    path="/skillglow/listpage/SkillGlow/AppraisalScoreBoard"
                    element={<AppraisalScoreBoard />}
                  />

                  {/* NEW SKILL DASHBOARD */}
                  {/* <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID3/listpage/SkillGlow/SkillResultDashboard"
                    element={<SkillResultDashboard />}
                  /> */}
                  <Route
                    path="/skillglow/listpage/SkillGlow/AppraisalDashboard"
                    element={<AppraisalDashboard />}
                  />

                  {/* SKILL GLOW */}

                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/manager/Editovertimeapproval/:id/:Mode"
                    element={<Editotentry />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/manager/Editleaveapproval/:id/:Mode"
                    element={<Editleaveentry />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/manager/Editondutyapproval/:id/:Mode"
                    element={<Editonduty />}
                  />
                  {/* Employee ---Expense */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/manager/Editfinanceapproval/:id/:Mode"
                    element={<Editfinance />}
                  />
                  {/* Employee ---Salary Advance */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/manager/EditSalary Advanceapproval/:id/:Mode"
                    element={<Editsalaryadvance />}
                  />
                  {/* Employee ---Regularization */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/manager/Editregularization-approval/:id/:Mode"
                    element={<EditRegularization />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/manager/EditQuery-approval/:id/:Mode"
                    element={<EditQuery />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/manager/EditPermission-approval/:id/:Mode"
                    element={<Editpermission />}
                  />

                  <Route
                    path="/:accessID/:screenName/EditOver Time/:id/:Mode"
                    element={<Editotentry />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditSalary Advance/:id/:Mode"
                    element={<Editsalaryadvance />}
                  />
                  {/* Query */}
                  <Route
                    path="/:accessID/:screenName/EditQuery/:id/:Mode"
                    element={<EditQuery />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditRegularization/:id/:Mode"
                    element={<EditRegularization />}
                  />
                  <Route path="/changepassword" element={<Changepassword />} />
                  <Route
                    path="/:screenName/imageupload/:accessID/:id"
                    element={<Imageupload />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditCompany/:id/:Mode"
                    element={<Editcompany />}
                  />
                  <Route
                    path="/:accessID/my-profile"
                    element={<Editemployee />}
                  />

                  <Route
                    path="/:accessID/EditAttendance"
                    element={<EditAttendance />}
                  />
                  {/* <Route
                    path="/:accessID/Editdailyattendance"
                    element={<EditdailyAttendance />}
                  /> */}

                  <Route
                    path="/:accessID/Feedback/EditFeedback/:id/:Mode"
                    element={<EditFeedback />}
                  />

                  <Route
                    path="/:accessID/Editmovements"
                    element={<Editmovements />}
                  />
                  <Route
                    path="/:accessID/EditAttendanceHistory"
                    element={<EditAttendanceHistory />}
                  />
                  <Route
                    path="/EditAttendanceEntry"
                    element={<EditAttendanceEntry />}
                  />
                  
                  <Route
                    path="/:accessID/EditTimeSheet"
                    element={<EditTimeSheet />}
                  />
                    <Route
                    path="/Teachers"
                    element={<EditTeacher />}
                  />
                    <Route
                    path="/TeacherInvoice"
                    element={<EditTeacherinvoice />}
                  />
                  
                  <Route
                    path="/:accessID/ProjectStatusReport"
                    element={<EditProjectStatusReport />}
                  />

                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Number"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Number/:Name"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:parentID/:Date/:FunctionDesc/:ProjectDesc"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Number/:Desc"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Number/:Desc/all-bom/:bomproductid"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Number/:Desc/:searchPharse/pm"
                    element={<ListviewSecondary />}
                  />
                  <Route path="*" element={<NotFound />} />
                  <Route
                    path="/:accessID/:screenName/EditFunctions/:id/:Mode"
                    element={<Editfunction />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditDesignation/:id/:Mode"
                    element={<Editdesignation />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditCheck In/:id/:Mode"
                    element={<Editcheckin />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/EditCheck In/:id/:Mode"
                    element={<Editcheckin />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditCheck Out/:id/:Mode"
                    element={<Editcheckout />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditScrum Task/:id/:Mode"
                    element={<EditDailytask />}
                  />
                  {/* <Route
                    path="/:accessID/:screenName/EditScrum Task/:id/:Mode"
                    element={<EditDailytask />}
                  /> */}
                  <Route
                    path="/:accessID/:screenName/Editleave/:id/:Mode"
                    element={<Editleaveentry />}
                  />
                  {/* Spot Activity */}
                  <Route
                    path="/:accessID/:screenName/EditOnsite Activities/:id/:Mode"
                    element={<EditSpotActivity />}
                  />
                  {/* On Duty */}
                  <Route
                    path="/:accessID/:screenName/EditOn Duty/:id/:Mode"
                    element={<Editonduty />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/EditCheck Out/:id/:Mode"
                    element={<EditEmpCheckout />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditLocation/:id/:Mode"
                    element={<Editlocation />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:parentID/EditGate Entry/:id/:Mode"
                    element={<Editgate />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:parentID/EditBins/:id/:Mode"
                    element={<Editbin />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:conscreenName/:filtertype/:Date/EditScrumTask/:id/:Mode"
                    element={<EditDailytask />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:parentID/:Date/:FunctionDesc/:ProjectDesc/EditDaily Hour Task/:id/:Mode"
                    element={<EditDailyHourstask />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditProject/:id/:Mode"
                    element={<Editproject />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditMilestones/:id/:Mode"
                    element={<EditMilestones />}
                  />
                  <Route
                  path="/Secondarylistview/:accessID/:screenName/:filtertype/EditTimeTable/:id/:Mode"
                  element={<EditTimetablev1 />}
                  />
                   <Route
                  path="/teacher-occupancy"
                  element={<TeacherOccupancy />}
                  />
                  <Route
                  path="/Secondarylistview/:accessID/:screenName/:filtertype/ProjectTimeTable"
                  element={<ProjectTimeTable />}
                  />
                     {/* <Route
                  path="/Secondarylistview/:accessID/:screenName/:filtertype/EditStdCalendarv1/:id/:Mode"
                  element={<EditStdCalendarv1 />}
                  /> */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditStages/:id/:Mode"
                    element={<Editoperation />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditActivities/:id/:Mode"
                    element={<EditActivities />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditTask/:id/:Mode"
                    element={<Edittask />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditSprint/:id/:Mode"
                    element={<EditSprint />}
                  />
                  <Route
                    path="/ProjectEnquiry"
                    element={<EditProjectEnquiry />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditRoutine Tasks/:id/:Mode"
                    element={<EditRoutine />}
                  />
                  <Route
                    path="/:accessID/:screenName/Editweightage/:Type/:id/:Mode"
                    element={<EditmileWeightage />}
                  />

                  <Route
                    path="/:accessID/:screenName/EditTimeScrumtask/:id"
                    element={<EditTimeDailytask />}
                  />
                  <Route
                    // path="/Secondarylistview/:accessID/:screenName/:parentID/EditExpense/:id/:Mode"
                    path="/Secondarylistview/:accessID/:screenName/:parentID/EditFinance Entry/:id/:Mode"
                    element={<Editfinance />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditOver Head/:id/:Mode"
                    element={<Editoverhead />}
                  />
                  <Route
                    path="/Edittimesheetreport"
                    element={<Edittimesheetreport />}
                  />

                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID"
                    element={<EditDailytaskList />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:conscreenName/:parentID/EditTasks/:id/:Mode"
                    element={<EditDailytaskListEdit />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditPermission/:id/:Mode"
                    element={<Editpermission />}
                  />
                  
                 
                   <Route
                    path="/:accessID/:screenName/EditHomework/:id/:Mode"
                    element={<EditHomework />}
                  />
                   <Route
                    path="/:accessID/:screenName/HomeWork/Analytics"
                    element={<HomeAnalytics />}
                  />
                  <Route
                    path="/:accessID/:screenName/Invoice/Analytics"
                    element={<InvoiceAnalytics />}
                  />

                   {/* <Route
                   path="/Secondarylistview/TR353/Tasks/368/EditEvaluation/11945/EV"
                    path="/:accessID/:screenName/EditEvaluation/:id/:Mode"
                    element={<EditHwevaluation />}
                  /> */}

                   <Route
                    path="/:screenName/EditRole/:Type/:id/:filtertype/:Mode"
                    element={<Editrole />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/:filtertype/EditPayment/:id/:Mode"
                    // Apps/Secondarylistview/TR332/Payment/21/EditPayment/-1/A
                    // /Apps/TR331/Invoice/EditInvoice/2/E
                    element={<EditPayment />}
                  />
                  <Route
                    path="/payment"
                    element={<Payment />}
                  />
                  <Route
                    path="/ResourceAllocation/:parentID2/:parentID1"
                    element={<ResourceAllocation />}
                  />
                </Routes>
              </main>
            </div>
          </MyProSidebarProvider>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
